import { GetExpenseResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteExpensePicture = () => {
    const queryClient = useQueryClient()

    return useMutation<
        GetExpenseResponse,
        Error,
        { tripId: string; expenseId: number; fileId: string }
    >({
        mutationFn: async ({ tripId, expenseId, fileId }) => {
            const response = await api.delete<GetExpenseResponse>(
                `/trips/${tripId}/expenses/${expenseId}/picture/${fileId}`,
            )
            return response.data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.expenses(variables.tripId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.files(variables.tripId) })
        },
    })
}
